jQuery(document).ready(function ($) {
    document.addEventListener(
        'wpcf7mailsent',
        function (event) {
            var form = event.target;
            var wrap = form && form.closest ? form.closest('.ah-inquire-form-wrap') : null;

            if (!wrap) {
                return;
            }

            if (!wrap.querySelector('.success_msg')) {
                $(wrap).append(
                    '<div class="success_msg">Thank you for your message. We will contact you shortly.</div>'
                );
            }

            $(form).hide();
        },
        false
    );
});
